import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import api from "@/lib/api";
import { usePlan, formatPrice } from "@/lib/plan";

export const fmtDate = (iso) => iso ? new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "";

// Status line derived only from /api/billing/me (Stripe-mirrored state + resolved access).
export function subscriptionStatusLine(info) {
  if (!info) return "";
  const s = info.subscription_status;
  if (info.managed_by_stripe && (s === "active" || s === "past_due")) {
    if (s === "past_due") return "Payment issue — please update your payment details";
    return info.cancel_at_period_end ? `Cancels on ${fmtDate(info.current_period_end)}` : `Renews on ${fmtDate(info.current_period_end)}`;
  }
  if (info.has_pro_access && info.access_source !== "stripe") {
    return info.is_owner ? "Owner access — no subscription needed" : info.is_lifetime ? "Lifetime access — no subscription needed" : "Education access — no subscription needed";
  }
  if (s === "active") return info.current_period_end ? `Pro access until ${fmtDate(info.current_period_end)}` : "Pro access — no automatic renewal";
  return "Free plan";
}

export function SubscriptionCard() {
  const plan = usePlan();
  const [info, setInfo] = useState(null);
  useEffect(() => { api.get("/billing/me").then((r) => setInfo(r.data)).catch(() => {}); }, []);
  const free = info && !info.has_pro_access && !(info.managed_by_stripe && info.subscription_status === "past_due");
  return (
    <div className="nb-card p-6 mt-6" data-testid="settings-subscription-card">
      <h3 className="font-cabinet font-bold text-xl flex items-center gap-2"><Crown className="w-5 h-5" /> Subscription</h3>
      <div className="mt-3 font-bold" data-testid="settings-subscription-plan">
        {free ? "Free" : `${plan?.name || "GetFluentLoop Pro"}${plan && info?.managed_by_stripe ? ` · ${formatPrice(plan)}/month` : ""}`}
      </div>
      <div className="text-sm text-gray-600 mt-1" data-testid="settings-subscription-status">{subscriptionStatusLine(info)}</div>
      <Link to="/billing" className={`${free ? "nb-btn-primary" : "nb-btn-outline"} mt-4 py-2 px-4 text-sm inline-flex`} data-testid="settings-manage-subscription">
        {free ? "Upgrade to Pro" : "Manage subscription"}
      </Link>
    </div>
  );
}
